import { BatteryStatusInterval, DEFAULT_COLOR_CLASSES } from '../constants/common';

export const findBatteryStatusInterval = (value: number): BatteryStatusInterval | undefined => {
    return DEFAULT_COLOR_CLASSES.find(c => c.min <= value && value <= c.max);
};
